export const SUPPORTED_LANGUAGES = ['en-GB', 'fi-FI', 'de-DE', 'nl-NL', 'nb-NO', 'sv-SE', 'pl-PL'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en-GB'

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
	'en-GB': 'English',
	'fi-FI': 'Suomi',
	'de-DE': 'Deutsch',
	'nl-NL': 'Nederlands',
	'nb-NO': 'Norsk',
	'sv-SE': 'Svenska',
	'pl-PL': 'Polski',
}
